/**
 * A global namespace for `Shift` key.
 * e.which = 16
 */
const keyShift = "Shift";

export default keyShift;
